/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { spacing, Text, useIsDesktopViewport } from "@packages/ui";
import type { PropsWithChildren } from "react";

const headerStyles: Interpolation = {
  paddingBlock: spacing.l,
};

export const SectionHeader = (props: PropsWithChildren) => {
  const isDesktop = useIsDesktopViewport();

  return (
    <Text
      as={"h2"}
      type={"headline"}
      size={isDesktop ? "m" : "l"}
      css={headerStyles}
    >
      {props.children}
    </Text>
  );
};
